import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';

// components
import CheckboxRadio from 'common/CheckboxRadio';

const baseString = 'vra-nitrapyrin';
const Nitrapyrin = ({
  disabled,
  onChange,
  selected=false
}) => {
  const classString = classNames({
    [`${baseString}`]: true
  });

  return (
    <section className={classString}>
      <div className='vra-planting-plan-form__inputs-wrapper'>
        <CheckboxRadio
          dataTestId={baseString}
          disabled={disabled}
          isChecked={selected}
          labelText={getMessage('label-text__nitrapyrin-application')}
          name='nitrapyrin'
          onChange={onChange}
        />
      </div>
    </section>
  );
};
Nitrapyrin.propTypes = {
  disabled: propTypes.bool,
  onChange: propTypes.func.isRequired,
  selected: propTypes.bool
};
export default Nitrapyrin;
